import { render, staticRenderFns } from "./GameBankvaultMemorizeViewDebug.vue?vue&type=template&id=48edba92&scoped=true&"
import script from "./GameBankvaultMemorizeViewDebug.vue?vue&type=script&lang=js&"
export * from "./GameBankvaultMemorizeViewDebug.vue?vue&type=script&lang=js&"
import style0 from "./GameBankvaultMemorizeViewDebug.vue?vue&type=style&index=0&id=48edba92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48edba92",
  null
  
)

export default component.exports